/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminthreads_Nooutput2Inputs */

const zh_adminthreads_nooutput2 = /** @type {(inputs: Adminthreads_Nooutput2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无输出`)
};

const en_adminthreads_nooutput2 = /** @type {(inputs: Adminthreads_Nooutput2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No output`)
};

const es_adminthreads_nooutput2 = /** @type {(inputs: Adminthreads_Nooutput2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin resultado`)
};

/**
* | output |
* | --- |
* | "No output" |
*
* @param {Adminthreads_Nooutput2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminthreads_nooutput2 = /** @type {((inputs?: Adminthreads_Nooutput2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminthreads_Nooutput2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminthreads_nooutput2(inputs)
	if (locale === "en") return en_adminthreads_nooutput2(inputs)
	return es_adminthreads_nooutput2(inputs)
});
export { adminthreads_nooutput2 as "adminThreads_noOutput" }